import type { CartCustomizationLike } from './CartCustomizationLike'

interface GroupedCartCustomizationOption {
  key: string
  option_id: number
  option_name: string
  quantity: number
  total_price_adjustment: number
}

interface GroupedCartCustomizationGroup {
  key: string
  group_id: number
  group_name: string
  options: GroupedCartCustomizationOption[]
}

export const groupCartCustomizations = (
  customizations: CartCustomizationLike[] | null | undefined
): GroupedCartCustomizationGroup[] => {
  if (customizations === null || customizations === undefined || customizations.length === 0) {
    return []
  }

  const groups = new Map<number, GroupedCartCustomizationGroup>()

  for (const customization of customizations) {
    const groupId = customization.group_id == null ? NaN : Number(customization.group_id)
    const optionId = customization.option_id == null ? NaN : Number(customization.option_id)
    const priceAdjustment = Number(customization.price_adjustment ?? 0)

    if (!Number.isFinite(groupId) || !Number.isFinite(optionId)) continue

    if (!groups.has(groupId)) {
      groups.set(groupId, {
        key: `group-${groupId.toString()}`,
        group_id: groupId,
        group_name: customization.group_name ?? '',
        options: []
      })
    }

    const group = groups.get(groupId)
    if (!group) continue

    const optionKey = `group-${groupId.toString()}-option-${optionId.toString()}`
    const adjustment = Number.isFinite(priceAdjustment) ? priceAdjustment : 0
    const existingOption = group.options.find((option) => option.option_id === optionId)

    if (existingOption) {
      existingOption.quantity += 1
      existingOption.total_price_adjustment += adjustment
      continue
    }

    group.options.push({
      key: optionKey,
      option_id: optionId,
      option_name: customization.option_name ?? '',
      quantity: 1,
      total_price_adjustment: adjustment
    })
  }

  return Array.from(groups.values())
}
